import logger from '3-foundation/Logging/logger';
import { mapAccordion } from './ContentModules/accordionMapper';
import { mapArticleMedia } from './ContentModules/articleMediaMapper';
import { mapArticleText } from './ContentModules/articleTextMapper';
import { mapBlurbCard } from './ContentModules/blurbCardMapper';
import { mapBookmarkMenu } from './ContentModules/bookmarkMenuMapper';
import { mapContentCard } from './ContentModules/contentCardMapper';
import { mapEventList } from './ContentModules/eventListMapper';
import { mapHeaderCard } from './ContentModules/headerCardMapper';
import { mapHeroCard } from './ContentModules/heroCardMapper';
import { mapLinkList } from './ContentModules/linkListMapper';
import { mapLocalNavigation } from './ContentModules/localNavigationMapper';
import { mapMap } from './ContentModules/mapMapper';
import { mapNewsletterSignup } from './ContentModules/newsletterSignupMapper';
import { mapNewsList } from './ContentModules/newsListMapper';
import { mapScriptModule } from './ContentModules/scriptModuleMapper';
import { mapSearch } from './ContentModules/searchMapper';
import { mapSharedContentModule } from './ContentModules/sharedContentModuleMapper';
import { mapSlider } from './ContentModules/sliderMapper';
import { mapVideoCard } from './ContentModules/videoCardMapper';
import { mapLinkListGrid } from './ContentModules/linkListGridMapper';
import { mapOrganisationList } from './ContentModules/organisationListMapper';
import { mapContentCardList } from './ContentModules/contentCardListMapper';
import { mapContactList } from './ContentModules/contactListMapper';
import { mapTagsList } from './ContentModules/tagsListMapper';
import { mapAnchor } from './PageSections/anchorMapper';
import { mapHeroCardSearch } from './ContentModules/heroCardSearchMapper';

const contentModuleMappers: Record<string, ({ content, settings, siteId, locale }) => Content.ContentModule | Promise<Content.ContentModule>> = {
	accordion: mapAccordion,
	anchor: mapAnchor,
	articleMedia: mapArticleMedia,
	articleText: mapArticleText,
	blurbCard: mapBlurbCard,
	bookmarkMenu: mapBookmarkMenu,
	contactList: mapContactList,
	contentCard: mapContentCard,
	contentCardList: mapContentCardList,
	eventList: mapEventList,
	headerCard: mapHeaderCard,
	heroCard: mapHeroCard,
	heroCardSearch: mapHeroCardSearch,
	linkList: mapLinkList,
	linkListGrid: mapLinkListGrid,
	localNavigation: mapLocalNavigation,
	map: mapMap,
	newsletterSignup: mapNewsletterSignup,
	newsList: mapNewsList,
	organisationList: mapOrganisationList,
	scriptModule: mapScriptModule,
	search: mapSearch,
	sharedContentModule: mapSharedContentModule,
	slider: mapSlider,
	tagsList: mapTagsList,
	videoCard: mapVideoCard,
};

export const mapContentModules = async (items: Umbraco.ContentModule[], siteId: string, locale: string): Promise<Content.ContentModule[]> => {
	try {
		return await Promise.all(
			items?.map(async (item) => {
				const mapper = contentModuleMappers[item.content?.contentType];
				if (mapper) {
					return await mapper({
						content: item.content,
						settings: item.settings,
						siteId,
						locale,
					});
				} else {
					logger.error(`No mapper found for content type: ${item.content?.contentType}`);
					throw new Error(`No mapper found for content type: ${item.content?.contentType}`);
				}
			}) ?? [],
		);
	} catch (error) {
		throw new Error(`Could not map Content Modules \nCause: ${error}`, {
			cause: error,
		});
	}
};
